import { render, staticRenderFns } from "./jspay.vue?vue&type=template&id=655bd5d0&"
import script from "./jspay.vue?vue&type=script&lang=js&"
export * from "./jspay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports